import { initPageCollect } from '@tencent/smp-tools';
import { UButton, UImage } from '@tencent/smp-ui';
import React from 'react';
import DefaultSmp from './defaultSmpData';
import './index.scss';
export default class App extends React.Component {
  constructor() {
    super();
    this.state = {
      subkey: '',
      channelVisible: false,
    };
    this.btnRef = React.createRef();
  }


  componentDidMount() {
    console.log('0.0.30-beta.39');
    // 通用上报
    const { stat = '' } = window.RENDER_DATA || DefaultSmp;;
    initPageCollect({
      statUrl: stat,
    });
  }

  handleBtnReady() {
    // 判断是否需要展示顶部应用信息
    const { appStatus } = this.btnRef.current.getAppStatus();
    this.setState({ appStatus });
  }

  handleBtnClick() {
    // const { app } = window.RENDER_DATA || DefaultSmp;
    // 按钮点击的地方，加抛包处理
    // window.location.href = app?.url;
  }

  getFlexiblePx(userSetHeight = 0, userSetBottom = 0) {
    if (window.screen.width > 750) {
      return parseFloat(userSetHeight) + parseFloat(userSetBottom);
    }
    return (parseFloat(userSetHeight) + parseFloat(userSetBottom)) * (window.screen.width / 750);
  }

  render() {
    const { appStatus = 6 } = this.state;
    const {
      btn,
      floatBtn,
      bg,
      stat = '',
    } = window.RENDER_DATA || DefaultSmp;

    let { app } = window.RENDER_DATA || DefaultSmp;
    app = {
      ...app,
      auto: false,
      autoActive: false,
      canpause: true,
    };
    return (
      <div className="main-panel">
        {bg
          ? <UImage ui={bg} className="bg" />
          : null}
        <div className="image-btn">
          {btn
            ? <UButton
              ref={this.btnRef}
              ui={btn}
              app={app}
              stat={stat}
              subkey='btn'
              onBtnReady={() => this.handleBtnReady()}
              onBtnClick={() => this.handleBtnClick()}
            />
            : null}
        </div>
        {floatBtn
          ? <UButton
            ref={this.btnRef}
            ui={floatBtn}
            app={app}
            stat={stat}
            subkey='floatBtn'
            onBtnReady={() => this.handleBtnReady()}
            onBtnClick={() => this.handleBtnClick()}
          />
          : null}

        {appStatus !== 6
          ? (
            <div style={{ fontSize: 10, margin: 0, padding: 6, textAlign: 'center' }}>
              <p style={{ margin: 0, padding: 2 }}>
                <span style={{ paddingRight: 4 }}>应用名称：QQ浏览器 版本：{window.qbversion || '11.1.6.6500'}</span>
                <span>更新时间：{window.qbupdatetime || '2022/06/07'}</span>
              </p>
              <p style={{ margin: 0, padding: 2 }}>
                开发者：深圳市腾讯计算机系统有限公司 &nbsp;
                <a style={{ color: 'gray', textDecoration: 'underline' }} href="https://upage.imtt.qq.com/app-info/qb.html">权限信息</a> &nbsp;
                <a style={{ color: 'gray', textDecoration: 'underline' }} href="https://privacy.qq.com/document/preview/2491347092a64d7fa00cbc2bf68fbbbb">隐私协议</a>
              </p>
            </div>
          )
          : null
        }
        {floatBtn
          ? <div
              style={{
                height: this.getFlexiblePx((floatBtn?.style?.outer?.height), (floatBtn?.style?.outer?.bottom)),
              }}
            ></div>
          : null}
      </div>
    );
  }
}
